<template>
  <Layout>
    <UiPageTitle title="Добавление сотрудника" :back-link="{ name: 'managers' }" />

    <div class="row">
      <div class="col-xs-12 col-sm-6"><ManagerInfo /></div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
import ManagerInfo from './managerInfo/ManagerInfo.vue'
import UiPageTitle from '@/components/UiPageTitle.vue'

export default {
  page: {
    title: 'Добавление сотрудника',
  },
  components: {
    Layout,
    ManagerInfo,
    UiPageTitle,
  },
}
</script>
